import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { map, of, switchMap } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { LocationRouteCffService } from '@fcom/core/services/location-routecff/location-routecff.service';
import { GlobalBookingTravelClass } from '@fcom/core/interfaces/global-booking-travel-class.interface';

import { CheapestPriceForAllDestinationsService } from '../../services/cheapest-price/cheapest-price-for-all-destinations.service';
import { FooterOffer } from '../../interfaces/offer.interface';

@Component({
  selector: 'cms-book-now',
  template: `
    @if (hasPrice()) {
      <fin-footer-offer [offer]="offer()" />
    }
  `,
  styleUrls: ['./cms-book-now.component.scss'],
  standalone: false,
})
export class CmsBookNowComponent {
  private cheapestPriceForAllDestinationsService = inject(CheapestPriceForAllDestinationsService);
  private locationRouteCffService = inject(LocationRouteCffService);
  private languageService = inject(LanguageService);

  locationCode = input<string>();

  private readonly locationCode$ = toObservable(this.locationCode);

  private readonly location = toSignal(
    this.locationCode$.pipe(
      switchMap((code) => {
        if (!code) {
          return of(undefined);
        }
        return this.locationRouteCffService.bestGuessFor(code, this.languageService.localeValue);
      })
    )
  );

  private readonly price = toSignal(
    this.locationCode$.pipe(
      switchMap((code) => {
        if (!code) {
          return of(undefined);
        }
        return this.cheapestPriceForAllDestinationsService.offerForSingleTrip(code, true).pipe(
          map((offer) => {
            return offer.prices.find((p) => p.travelClass.toUpperCase() === GlobalBookingTravelClass.ECONOMY)?.price;
          })
        );
      })
    )
  );

  offer = computed<FooterOffer>(() => {
    return { locationCode: this.locationCode(), location: this.location()?.title ?? '' };
  });

  hasPrice = computed(() => {
    return Boolean(this.price());
  });
}
